import { useEffect } from 'react'
import Navigation from '@/components/Navigation'
import filmabeeLogoSrc from '@assets/Logo_White_TansparentBG_1774986397984.png'
import { trackEvent } from '@/lib/analytics'

const GetInTouchPage = () => {
  useEffect(() => {
    const existing = document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]')
    if (!existing) {
      const script = document.createElement('script')
      script.src = 'https://static.elfsight.com/platform/platform.js'
      script.async = true
      document.head.appendChild(script)
    }
  }, [])

  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />

      <div className="pt-28 pb-20 px-6">
        <div className="max-w-6xl mx-auto">

          {/* Centred heading */}
          <div className="text-center mb-6 lg:mb-12">
            <h1 className="font-bebas text-5xl md:text-7xl text-red-600 tracking-wide mb-4">
              GET IN TOUCH
            </h1>
            <p className="font-poppins text-neutral-400 text-lg">
              Interested in being part of the journey? We'd love to hear from you.
            </p>
          </div>

          <div className="flex flex-col lg:flex-row lg:gap-8 lg:items-center">

            {/* Left — logo, shifted right from edge */}
            <div className="flex flex-col items-center lg:items-center lg:w-72 lg:flex-shrink-0 mb-6 lg:mb-0 lg:pl-20">
              <a href="/" aria-label="Filmabee Studios">
                <img
                  src={filmabeeLogoSrc}
                  alt="Filmabee Studios"
                  className="w-64 lg:w-80"
                />
              </a>
            </div>

            {/* Right — Elfsight form */}
            <div className="flex-1 min-w-0">
              <div
                className="elfsight-app-836151d1-a8d2-4dfe-a5df-1de1582d2a40"
                data-elfsight-app-lazy
                onClick={() => trackEvent('contact_click', { site: 'the-monsters-we-make', film: 'the-monsters-we-make', placement: 'contact_widget', provider: 'elfsight' })}
              ></div>
            </div>

          </div>

          {/* Back link — centered below everything */}
          <div className="text-center mt-12">
            <a
              href="/the-monsters-we-make"
              className="font-poppins text-sm text-neutral-500 hover:text-white transition-colors tracking-wide underline"
            >
              ← Back to the film
            </a>
          </div>

        </div>
      </div>
    </div>
  )
}

export default GetInTouchPage
